<template>
    <!-- DoorDash's secondary button, the side panels' outlined Cancel (sweep 2026-11-04) -->
    <v-btn
        :outlined="!plain"
        depressed
        :block="block"
        :plain="plain"
        @click="$emit('cancel')"
    >
        {{ label }}
    </v-btn>
</template>

<script>
export default {
    props: {
        text: {
            type: String,
            default: null,
        },
        block: Boolean,
        plain: Boolean,
    },
    computed: {
        label() {
            return this.text ?? this.$t('actions.cancel')
        },
    },
}
</script>
